<template>
  <img :src="summary_details" alt="" width="100%" />
</template>

<script>
import summary_details from "@/assets/images/summary_details.svg";
export default {
  name: "SummarySkeleton",
  data() {
    return {
      summary_details,
    };
  },
};
</script>

<style scoped></style>
